import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/AlfaPack_Logo_Vectores_Blanco.png'


const _hoisted_1 = { class: "hero is-primary" }
const _hoisted_2 = { class: "hero-body pb-3" }
const _hoisted_3 = { class: "container pb-0" }
const _hoisted_4 = { class: "level is-mobile" }
const _hoisted_5 = { class: "level-item level-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  alt: "AlfaPack_Logo_Vectores_Blanco.png",
  src: _imports_0,
  width: "150"
}, null, -1)
const _hoisted_7 = { class: "level-item level-right" }
const _hoisted_8 = {
  href: "https://www.linkedin.com/company/alfapacksolutions/about/?viewAsMember=true",
  target: "_blank"
}
const _hoisted_9 = {
  href: "https://www.youtube.com/@alfapacksolutions",
  target: "_blank"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "columns is-mobile" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "column is-three-quarters-desktop is-three-quarters-tablet is-three-quarters-widescreen is-three-quarters-fullhd is-full-mobile" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "has-text-white is-size-6" }, " Asesoramos e integramos tecnología en las industrias de alimentos, bebidas, farmacéutica y empaque. Ofrecemos capacitación, servicios y piezas de repuesto para mantener a nuestros clientes actualizados y sus máquinas en perfecto estado. ")
    ])
  ])
], -1)
const _hoisted_11 = { class: "block pb-0" }
const _hoisted_12 = { class: "columns is-mobile pb-0" }
const _hoisted_13 = { class: "column pb-0 is-mobile" }
const _hoisted_14 = { class: "has-text-white is-size-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "column has-text-right has-text-bottom pb-0 is-mobile" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button is-normal has-background-green has-text-white has-text-weight-bold",
    style: {"font-family":"Calibri"}
  }, " Chatea en vivo con Alfapack ")
], -1)

import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLinkedin, mdiYoutube } from "@mdi/js";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "navbar-item is-hoverable"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _createVNode(_unref(SvgIcon), {
                  class: "mr-4",
                  type: "mdi",
                  path: _unref(mdiLinkedin),
                  style: {"color":"#white","width":"40px","height":"40px"}
                }, null, 8, ["path"])
              ]),
              _createElementVNode("a", _hoisted_9, [
                _createVNode(_unref(SvgIcon), {
                  type: "mdi",
                  path: _unref(mdiYoutube),
                  style: {"color":"#white","width":"45px","height":"45px"}
                }, null, 8, ["path"])
              ])
            ])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, " Derechos Reservados " + _toDisplayString(_unref(currentYear)) + " © ", 1)
              ]),
              _hoisted_15
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}
}

})